<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Orbitron:wght@400;600;700;900&display=swap');
@import './assets/tech-theme.css';

#app {
  min-height: 100vh;
  background: #f5f6fa;
  font-family: 'Roboto', 'Arial', sans-serif;
}

/* 全局样式重置 */
* {
  box-sizing: border-box;
}

body {
  margin: 0;
  padding: 0;
  background: var(--dark-gradient);
  color: white;
}

/* Element UI 组件简化覆盖 */
.el-card {
  background: white !important;
  border: 1px solid #e4e7ed !important;
  border-radius: 8px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
}

.el-button--primary {
  background-color: #409eff !important;
  border-color: #409eff !important;
  color: white !important;
}

.el-button--primary:hover {
  background-color: #66b1ff !important;
  border-color: #66b1ff !important;
}

.el-input__inner {
  background: white !important;
  border: 1px solid #dcdfe6 !important;
  border-radius: 4px !important;
  color: #333 !important;
}

.el-input__inner:focus {
  border-color: #409eff !important;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2) !important;
}

.el-table {
  background: white !important;
  border-radius: 8px !important;
  overflow: hidden !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
}

.el-table th {
  background: #f5f7fa !important;
  color: #333 !important;
  border-bottom: 1px solid #ebeef5 !important;
  font-weight: 600 !important;
}

.el-table td {
  background: white !important;
  color: #333 !important;
  border-bottom: 1px solid #ebeef5 !important;
}

.el-pagination {
  background: white !important;
  border-radius: 4px !important;
  padding: 8px !important;
}

.el-pagination .el-pager li {
  background: white !important;
  color: #333 !important;
  border: 1px solid #d9d9d9 !important;
}

.el-pagination .el-pager li:hover,
.el-pagination .el-pager li.active {
  background: #409eff !important;
  color: white !important;
}

.el-tag {
  background: #409eff !important;
  border: none !important;
  border-radius: 4px !important;
  color: white !important;
  font-weight: 500 !important;
}

/* 去掉表格底部的突兀元素 */
.el-table__footer-wrapper {
  display: none !important;
}

.el-table__fixed-footer-wrapper {
  display: none !important;
}
</style>
